/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PiggyBankIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABKElEQVR4nO1UsUrEQBDND1gJ4qfIEcHylJ15s0icCehHXG8h+AFiY2fpd3iFlY1WfoCWopx6lQgeEQ5Mds8ca9LdgykS3r73ZiabLFshBSJH6yx2zLBbgr2w2HdYOiXRO4ZdEOyBYF/Ve4Ke/ylOoo5F3+Ki1l5so4XiDuX+PMnvAnQQcKXMmzwSuwoTQy8ZOiZvQxZ9jqVyUubNc4BuR8b2ulcUmzViJZ48DgmLoCd1A+Y1Fj0j6GeHJk9OdLduJDrttBOxx4ZBuhigg9jSOzNwUuaxpTe+JvvockQcdAC779WAoKe9Ltn7ww0Se+9KnLwNg1vNXov/igO6EwjXRiV2nWwAu8naUCXoLf3C/xN03M5ZIv0c5A+2CDb5WRhsUj2ncFbIlsEMemNenj4ksAAAAAAASUVORK5CYII=)
 */
export const PiggyBankIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2.1 8.83C2.03 9.21 2 9.6 2 10v2c0 1.85.72 3.54 1.9 4.79l1.82 3.66a1 1 0 0 0 .9.55h1.76a1 1 0 0 0 .9-.55L10 19h4l.72 1.45a1 1 0 0 0 .9.55h1.76a1 1 0 0 0 .9-.55L20.5 16h.5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.29c-.27-.9-.7-1.72-1.29-2.42l1.09-1.09A.87.87 0 0 0 19.89 3h-1.48c-.63 0-1.25.18-1.79.5-.8-.32-1.7-.5-2.62-.5H9a7 7 0 0 0-6.3 3.93 2 2 0 0 1-.87-.52L1.7 6.3A1 1 0 0 0 .29 7.71l.12.12a4 4 0 0 0 1.69 1ZM9 6a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm9 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
